export default __webpack_public_path__ + "static/media/blackBG.36d19e75.png";